import { combineReducers, createFeature } from '@ngrx/store';

import { operatorSettingsCurrencyReducer } from './currency/reducers/currency.reducer';
import { operatorSettingsReducer } from './reducers/operator-settings.reducer';

export const operatorSettingsFeatureKey = 'operatorSettings';

const operatorSettingsRootReducer = combineReducers({
  operatorSettings: operatorSettingsReducer,
  currency: operatorSettingsCurrencyReducer,
});

export const operatorSettingsFeature = createFeature({
  name: operatorSettingsFeatureKey,
  reducer: operatorSettingsRootReducer,
});
